import { TextInput } from 'carbon-components-react';

export function StudentSearchField({
  value,
  onChange,
  id = 'student-search',
  labelText = '',
  placeholder = 'Search by student name or class',
  className = '',
}) {
  return (
    <TextInput
      id={id}
      name={id}
      labelText={labelText}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      className={className}
    />
  );
}
